// Asks the server (netlify/functions/help-message-email.ts) to send one of
// the two help-message emails: the alert to DodoSkills staff after someone
// sends a message, or the reply to the person who asked. Best effort -- the
// message and the reply are already saved, so a failed email never undoes
// or blocks them.
export async function sendHelpMessageEmail(
  request:
    | { kind: 'new_message' }
    | { kind: 'reply'; source: 'message' | 'report'; id: string },
  accessToken: string,
): Promise<boolean> {
  try {
    const response = await fetch('/api/help/message-email', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(request),
    });
    return response.ok;
  } catch {
    return false;
  }
}
